import config from "../config";

let url = function (alias) {
  switch (alias) {
    case "HOME_URL":
      return config.DEBUG ? config.home_url : config.home_url_prod;
    case "LOGIN_URL":
      return config.DEBUG ? config.login_url : config.login_url_prod;
    case "DOMAIN_NAME":
      return config.DEBUG ? config.domain_name : config.domain_prod_name;
    case "FORGOT_PASSWORD_URL":
      return config.DEBUG
        ? config.forgot_password_url
        : config.forgot_password__url_prod;
    case "RESET_FORGOT_PASSWORD_URL":
      return config.DEBUG
        ? config.reset_forgot_password_url
        : config.reset_forgot_password__url_prod;
    case "FORCE_CHANGE_PASSWORD_URL":
      return config.DEBUG
        ? config.force_change_password_url
        : config.force_change_password_url_prod;
    case "URL":
      return config.DEBUG ? config.uatURL : config.uatURL;
  }
};

export default url;
